import {
  FuelStop, FuelStopApi, FuelStopMutation, SuggestedFuelStop, TimestampRequestBody // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import { AxiosPromise, AxiosResponse } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath() + '/my-trips'

export default class ExtendedStopFuelApi extends FuelStopApi {
  getFuelStop (vehicleId: number, id: number, options?: any): AxiosPromise<FuelStop> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getFuelStop(vehicleId, id, undefined, optionsParam)
  }

  getSuggestedFuelStops (vehicleId: number, filterFrom?: string, filterUntil?: string, options?: any): AxiosPromise<Array<SuggestedFuelStop>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getSuggestedFuelStops(vehicleId, undefined, filterFrom, filterUntil, optionsParam)
  }

  createFuelStop (vehicleId: number, body: FuelStopMutation, options?: any): AxiosPromise<FuelStop> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.createFuelStop(vehicleId, body, undefined, options)
  }

  updateFuelStop (vehicleId: number, id: number, body: FuelStopMutation, options?: any): AxiosPromise<FuelStop> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.updateFuelStop(vehicleId, id, body, undefined, options)
  }

  deleteFuelStop (vehicleId: number, id: number, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.deleteFuelStop(vehicleId, id, undefined, options)
  }

  hideSuggestedFuelStop (vehicleId: number, timestamp: TimestampRequestBody, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.hideSuggestedFuelStop(vehicleId, timestamp, undefined, options)
  }

  showAllSuggestedFuelStops (vehicleId: number, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.showAllSuggestedFuelStops(vehicleId, undefined, options)
  }
}
